import React, { Component } from 'react'
import { Alert } from 'loyal-react'
import ProductOrderItemDonation from './ProductOrderItemDonation'
import PropTypes from 'prop-types'
import '@loyal_template/cart.css'
import '@loyal_template/confirmation.css'
import { AboutOrderDonation } from '../AboutOrderDonation'
import clients from 'redux/clients'

class ConfirmationDonation extends Component {
  constructor (props) {
    super(props)
    const {
      cloudloyalty: { client }
    } = clients
    this.client = client
  }

  componentDidMount () {
    if (this.props.orderId) {
      this.props.getOrder(this.props.orderId)
      const utmURL = window.sessionStorage.getItem('utm-url')
      if (utmURL) {
        this.client
          .post(`v1/purchases/utm`, {
            ParentOrderId: this.props.orderId,
            Url: utmURL
          })
      }
    }
  }

  state = {
    showModal: false,
    hideModal: true,
    orderId: 0
  }

  toogleModal = () => {
    this.setState({ showModal: !this.state.showModal })
  }

  render () {
    if (this.props.order.notFound) {
      this.props.redirectNotFoundPage()
    }
    return (
      <div
        className='container-cart container pt-5 pt-md-2 pb-5'
        onLoad={e => this.toogleModal()}
      >
        <div className='d-block d-md-none pb-5' />
        <div className='row mt-5 mt-md-0 mb-2'>
          <Alert
            isError={false}
            title='Obrigado! Sua doação foi concluída com sucesso.'
            description='Acompanhe todos os detalhes nos seus pedidos.'
          />
        </div>
        <div className='row'>
          <div className='cart-side col-12 col-md-8 pl-0 pr-0 pr-md-2'>
            <div className='border-ui-3 radius bg-white'>
              <div className='col-12 py-3 px-3 mx-0  border-color-ui-3 border-bottom'>
                <h3 className='color-title txt-font-body'>Resumo da doação</h3>
              </div>
              <div className='cart-products col-12 mx-0'>
                {this.props.order.vendorOrderModel
                  ? this.props.order.vendorOrderModel.map(vendorItem =>
                    vendorItem.items.map((item, index) => (
                      <ProductOrderItemDonation
                        key={index}
                        productName={item.name}
                        orderParentId={this.props.order.parentOrderId}
                        costPrice={item.costPrice}
                        quanttity={item.quantity}
                        vendorName={vendorItem.vendorName}
                        deliveryDate={item.deliveryForecast}
                        orderId={vendorItem.orderId}
                        parentOrderId={this.props.order.parentOrderId}
                        productId={item.id}
                        imageUrl={item.imageUrl}
                        vendorId={vendorItem.vendorId}
                        vendorType={vendorItem.vendorType}
                      />
                    ))
                  )
                  : ''}
              </div>
            </div>
          </div>
          <AboutOrderDonation parentOrder={this.props.order} />
        </div>
      </div>
    )
  }
}

ConfirmationDonation.propTypes = {
  order: PropTypes.object,
  orderId: PropTypes.number,
  getOrder: PropTypes.func,
  redirectNotFoundPage: PropTypes.func
}
export default ConfirmationDonation



// WEBPACK FOOTER //
// ./src/features/ConfirmationDonation/ConfirmationDonation.js